import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, UncontrolledTooltip } from "reactstrap";
import { BsChevronDoubleLeft, BsChevronDoubleRight } from "react-icons/bs";

import "bootstrap/dist/css/bootstrap.min.css";
import "../elements/Styles.css";
import GetTokenApi from "../pages/KeyCloak/GetTokenApi";
import { useEffect } from "react";
import useProjectTypeStore from "../store/useProjectTypeStore";

const SideBarMap = (props) => {
  const [userPermission, setUserPermission] = useState(null);
  const [secondaryMenuContentOpen, setSecondaryMenuContentOpen] =
    useState(null);
  const [content, setContent] = useState(null);
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);

  const [orientationMode, setOrientationMode] = useState(null);
  const [leftMenu, setLeftMenu] = useState(false);
  const [leftMenuOpen, setLeftMenuOpen] = useState(false);

  const projectType = useProjectTypeStore((state) => state.projectType);

  useEffect(() => {
    if (props.hideLeftMenu[0]) {
      setLeftMenuOpen(false);
      props.hideLeftMenu[1](false);
    }
  }, [props]);

  useEffect(() => {
    if (windowSize !== [window.innerWidth, window.innerHeight]) {
      setWindowSize(null);
      setWindowSize([window.innerWidth, window.innerHeight]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.innerWidth, window.innerHeight]);

  useEffect(() => {
    // handleResize();
    if (
      windowSize &&
      windowSize[0] &&
      windowSize[1] &&
      windowSize[0] <= windowSize[1]
    ) {
      setOrientationMode("portrait");
      setLeftMenu(true);
    } else if (
      windowSize &&
      windowSize[0] &&
      windowSize[1] &&
      windowSize[0] > windowSize[1]
    ) {
      setOrientationMode("landscape");
      setLeftMenu(false);
    } else {
      setOrientationMode(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowSize]);

  if (!userPermission)
    GetTokenApi().then((res) => {
      setUserPermission(res);
    });

  useEffect(() => {
    let auxContent = [];
    Object.entries(props).forEach((propsItem) => {
      if (propsItem[0] === "filters") {
        propsItem[1].forEach((e, index) => {
          if (!isFromCurrentProjectType(e[4])) return;

          const tooltipId = `lamp-filter-tool-tip-${index}`;
          auxContent.push(
            <div key={Math.random()}>
              <div className="m-0 mb-auto item-menu" key={Math.random()}>
                <div
                  className="btn btn-light d-flex justify-content-center align-items-center"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    marginTop: "10px",
                    marginLeft: "1px",
                    marginBottom: "10px",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.8)",
                    textDecoration: "none",
                  }}
                  onClick={() => {
                    if (e[0]) {
                      e[1](false);
                    } else {
                      props.closeAllMenus();
                      e[1](true);
                    }
                  }}
                >
                  <h3
                    className="text-black-50 m-0 text-center icon-menu"
                    id={tooltipId}
                  >
                    {e[2]}
                  </h3>

                  <UncontrolledTooltip placement="right" target={tooltipId}>
                    {e[3]}
                  </UncontrolledTooltip>
                </div>
              </div>
            </div>
          );
        });
      } else if (propsItem[0] === "pointTable") {
        propsItem[1].forEach((e) => {
          auxContent.push(
            <div key={Math.random()}>
              <div
                className="btn btn-light d-flex justify-content-center align-items-center"
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  marginTop: "10px",
                  marginLeft: "1px",
                  marginBottom: "10px",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.8)",
                  textDecoration: "none",
                }}
                onClick={() => {
                  if (e[1]) {
                    e[0](false);
                  } else {
                    props.closeAllMenus();
                    setLeftMenu(false);
                    setSecondaryMenuContentOpen(false);
                    e[0](true);
                  }
                }}
                key={Math.random()}
              >
                <h3
                  className="text-black-50 m-0 text-center icon-menu"
                  id="points-table-tool-tip"
                >
                  <img alt="icon" src="/imgs/TABELA.svg" className="icon" />
                </h3>

                <UncontrolledTooltip
                  placement="right"
                  target="points-table-tool-tip"
                >
                  Tabela de Postes
                </UncontrolledTooltip>
              </div>
            </div>
          );
        });
      }

      setContent(auxContent);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, secondaryMenuContentOpen]);

  function isFromCurrentProjectType(types) {
    const allowedTypes = Array.isArray(types) ? types : [types];
    return allowedTypes.includes(projectType);
  }

  return (
    <>
      {leftMenu &&
      orientationMode &&
      orientationMode === "portrait" &&
      !secondaryMenuContentOpen ? (
        <Link
          className={
            "row m-0 p-0 left-menu-arrow-control" +
            (leftMenuOpen ? " left-menu-arrow-control-open" : "")
          }
          style={{ zIndex: "1050" }}
          onClick={() => {
            if (leftMenuOpen) {
              setLeftMenuOpen(false);
            } else {
              setLeftMenuOpen(true);
            }
          }}
        >
          <h3 className="mt-auto ms-auto me-3 p-0">
            {leftMenuOpen ? <BsChevronDoubleLeft /> : <BsChevronDoubleRight />}
          </h3>
        </Link>
      ) : (
        ""
      )}
      <div
        id="barraLateral"
        className={
          "menu-lateral text-center m-0 pt-4 p-1" +
          (orientationMode && orientationMode === "portrait"
            ? " menu-left-portrait"
            : "") +
          (leftMenuOpen ? " menu-lateral-left-portrait-open" : "")
        }
      >
        <Row className="m-0 p-0" key={Math.random()}>
          <Col className="m-0 p-0" key={Math.random()}>
            {content && content}
          </Col>
        </Row>
      </div>
    </>
  );
};
export default SideBarMap;
